import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal, Form, } from 'react-bootstrap';
import { BsGear } from 'react-icons/bs';
import imagemLogo from '../../images/Logo.png';
import api from '../../services/api';

function Header() {

    const [lista, setLista] = useState([]);

    useEffect(() => {
        async function fetchLista() {

            try {
                const response = await api.get(`/Pesquisa/PostoLista`)
                setLista(response.data);
                //console.log(response.data);
            } catch (e) {
                console.error(e);
            }
        }
        fetchLista();
    }, []);
    let filtroLista = [];
    for (let i = 0; i < lista.length; i++) {
        filtroLista[i] = { id: lista[i].POSTO, nome: lista[i].NOME, codigo: lista[i].POSTO }
    }

    // modal
    var url2 = window.location.href;
    url2 = url2.replace(window.location.search, "");

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // formulário
    const [posto, setPosto] = useState("");
    const [filtro, setFiltro] = useState("");

    const handleChangeTipo = (event) => {
        console.log(event)
        if (event.target.id !== "") {
            localStorage.setItem("tipo", event.target.id);
        }
        setFiltro(event.target.id);
    }

    const handleChangePosto = (event) => {
        setPosto(event.target.value.split(" ", 1));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        window.location.href = url2 + `?postos=${posto}&tipo=${filtro}`
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>Selecione o Posto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <fieldset>
                            <Form.Group as={Row} >
                                <Form.Label as="legend" column sm={3} className="mt-1 pt-0 text-primary">
                                    <h5>Filtro :</h5>
                                </Form.Label>
                                <Form.Check
                                    type="radio"
                                    label="TRIADO"
                                    name="filtroTriado"
                                    id="0"
                                    className="mr-2 mt-1 ml-0 teste"
                                    value={filtro}
                                    onChange={handleChangeTipo}
                                    required
                                />
                                <Form.Check
                                    type="radio"
                                    label="NÃO TRIADOS"
                                    name="filtroTriado"
                                    id="1"
                                    className="mr-2 mt-1 ml-3 teste"
                                    value={filtro}
                                    onChange={handleChangeTipo}
                                    required
                                />
                                <Form.Check
                                    type="radio"
                                    label="TODOS"
                                    name="filtroTriado"
                                    id="2"
                                    className="mr-2 mt-1 ml-3 teste"
                                    value={filtro}
                                    onChange={handleChangeTipo}
                                    required
                                />
                            </Form.Group>
                        </fieldset>


                        <Form.Group controlId="exampleForm.ControlSelect2">
                            <Form.Label className="text-primary" ><h5>Escolha o Posto:</h5></Form.Label>
                            {" "}
                            <input
                                class="form-control"
                                type="text"
                                list="lista"
                                onChange={handleChangePosto}
                                placeholder="Digite o código ou nome..."
                                required
                            ></input>
                            <datalist id="lista">
                                {filtroLista.map((item, index) => (
                                    <option
                                        key={`item_${index}`}
                                        valeu={item.codigo}
                                    >
                                        {item.codigo} | {item.nome}
                                    </option>
                                ))}
                            </datalist>
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Confirmar
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            <header>
                <Container fluid>
                    <Row>
                        <Col sm={1} className="Img-logo">
                            <img src={imagemLogo} width="50" alt='Logo AR Sistemas' />
                        </Col>
                        <Col className="Title-h1">
                            <h1>
                                MONITOR DE ATRASOS - AR SISTEMAS
                            </h1>
                        </Col>

                        <Col sm={1} className="bt-option">
                            <Button className="btn-Op btn-light" onClick={handleShow} ><BsGear /></Button>
                        </Col>
                    </Row>
                </Container>
            </header>
        </>
    );
}

export default Header;